module.exports = __webpack_public_path__ + "img/ball-second-block-bg.e41365bf.jpg";